import React from 'react';
import './Hero.css';

const Hero = () => {
  return (
    <section id="hero" className="hero">
      <div className="hero-background">
        <div className="hero-overlay"></div>
      </div>
      
      <div className="container">
        <div className="hero-content">
          <div className="hero-badge">
            <span className="badge-icon">🔥</span>
            <span>America's Most Twisted Road</span>
          </div>
          
          <h1 className="hero-title">
            <span className="title-line-1">Devil's Highway</span>
            <span className="title-line-2">Motorcycle Tours</span>
          </h1>
          
          <div className="hero-stats">
            <div className="stat">
              <span className="stat-number">650</span>
              <span className="stat-label">Turns</span>
            </div>
            <div className="plus">
              +
            </div>            
            <div className="stat">
              <span className="stat-number">120</span>
              <span className="stat-label">Miles</span>
            </div>
            <div className="plus">
              +
            </div>              
            <div className="stat">
              <span className="stat-number">3</span>
              <span className="stat-label">Days</span>
            </div>
            <div className="plus">
              =
            </div>              
            <div className="stat">
              <span className="stat-number">666+</span>
              <span className="stat-label">Total Miles</span>
            </div>
          </div>
          
          <p className="hero-description">
            Experience the legendary Route 666 (now US 191) through Arizona and New Mexico. 
            Professional guided motorcycle tours on America's most technical and scenic ride.
          </p>
          
          <div className="hero-cta">
            <a href="#booking" className="btn btn-primary">
              Book Your Adventure
            </a>
            <a href="#tour-details" className="btn btn-secondary">
              Learn More
            </a>
          </div>
          
          <div className="hero-features">
            <div className="feature">
              <span className="feature-icon">🏍️</span>
              <span>Professional Guide</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🏨</span>
              <span>2 Nights Lodging</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🍽️</span>
              <span>Group Meals</span>
            </div>
            <div className="feature">
              <span className="feature-icon">🏆</span>
              <span>Souvenir Patch</span>
            </div>
          </div>
        </div>
      </div>
      
      <div className="hero-scroll">
        <div className="scroll-indicator">
          <span>Scroll Down</span>
          <div className="scroll-arrow">↓</div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
